import { useTranslation } from 'react-i18next';

import { DetailedBookingIMPMainFormFieldErrors } from '../../interface/DetailedBookingInterface';
import {
  FieldContainer,
  FieldLabel,
} from '../CreateBookingForm/CreateDetailedBookingForm.styles';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface ImpressionsBlockedFieldProps {
  hasValidationBeenTriggered: boolean;
  fieldErrors: DetailedBookingIMPMainFormFieldErrors;
  impressionsBlockedOverContextualNodeValue: string;
}

const ImpressionsBlockedFieldIMP = ({
  hasValidationBeenTriggered,
  fieldErrors,
  impressionsBlockedOverContextualNodeValue,
}: ImpressionsBlockedFieldProps) => {
  const { t } = useTranslation();

  const errorsToShow = hasValidationBeenTriggered
    ? fieldErrors
    : {
        entryNumber: '',
        slotForGP: '',
        valueBlockedByLineItem: '',
        impressionsBlockedOverContextualNode: '',
      };

  return (
    <FieldContainer id="impressions-blocked-over-contextual-node-field">
      <FieldLabel>{t('impressions-blocked-label')}</FieldLabel>
      <FormFieldWrapper
        id="impressions-blocked-field"
        type="input"
        value={impressionsBlockedOverContextualNodeValue}
        onChange={() => {}} // This is disabled, so onChange won't be called
        placeholder="impressions-blocked-placeholder"
        disabled={true}
        error={errorsToShow.impressionsBlockedOverContextualNode}
      />
    </FieldContainer>
  );
};

export default ImpressionsBlockedFieldIMP;
